import Importer from './Importer';
import Dot from '../track/Dot';
import Dots from '../track/Dots';
import Event from '../track/Event';

export default class ImporterXML extends Importer {
  constructor(fileName, fileData) {
    super(fileName, fileData);

    this.SEGMENTS_TAG = 'tache';

    this.EVENTS_MAPPING = {
      0: { id: 65542, name: 'Both sides' },
      1: { id: 65540, name: 'Right side' },
      2: { id: 65541, name: 'Left side' },
      3: { id: 65540, name: 'Right side' },
      4: { id: 65542, name: 'Both sides' },
      5: { id: 65539, name: 'Transfer' },
      6: { id: 65552, name: 'Backwards' }
    };
  }

  import() {
    let dots = new Dots();
    let latestAddedEvent = { name: '' };

    let file = this.parseFile();

    let segments = file.getElementsByTagName(this.SEGMENTS_TAG);

    for (let i = 0; i < segments.length; i++) {
      // dots is an object so it's always passed by reference in JS
      this.addPoints(dots, segments[i], latestAddedEvent);
    }

    return dots;
  }

  addPoints(dots = {}, segment, latestAddedEvent = {}) {
    if (segment !== 'undefined') {
      let points = segment.getElementsByTagName('point');
      for (let i = 0; i < points.length; i++) {
        let event;

        if (i === 0) {
          let eventName = this.getStartEventName(segment.getAttribute('typecollecte'));

          if (eventName !== latestAddedEvent.name) {
            // eslint-disable-next-line no-param-reassign
            latestAddedEvent.name = eventName;
            event = this.getStartEvent(segment);
          }
        }

        dots.add(new Dot(
          parseFloat(points[i].getAttribute('Latitude')),
          parseFloat(points[i].getAttribute('Longitude')),
          event
        ));
      }
    }
  }

  parseFile() {
    let parser = new DOMParser();
    return parser.parseFromString(this._fileData, 'application/xml');
  }

  getStartEvent(segment) {
    return new Event(
      this.getStartEventId(segment.getAttribute('typecollecte')),
      this.getStartEventName(segment.getAttribute('typecollecte')),
      '',
      '#FFF',
      true,
      true
    );
  }

  getStartEventId(eventId) {
    return this.EVENTS_MAPPING[eventId].id;
  }

  getStartEventName(eventId) {
    return this.EVENTS_MAPPING[eventId].name;
  }
}
